var url = window.location.href.toString();

// como true ele vai mostrar
var flags = [
  {
    name: "notificacaoAniversario",
    isActive: false,
  },
];

// ambiente de QA
if (url.toString().includes("qa.podemorar.com.br")) {
  flags[0].isActive = false;
}

// ambiente de testes
else if (url.toString().includes("teste")) {
  flags[0].isActive = false;
}

// ambiente de STAGE
else if (url.toString().includes("stage.podemorar.com.br")) {
  flags[0].isActive = false;
}
// ambiente de DEV
else if (
  url.toString().includes("dev.podemorar.com.br") ||
  url.toString().includes("localhost")
) {
  flags[0].isActive = true;
}
// ambiente de PROD
else {
  flags[0].isActive = false;
}

export default flags;
